function updateFlag(flag, value, apiClient) {
  const route = apiClient.route `/featureFlags/${flag}`;
  return apiClient.patch(route, { enabled: value });
}

export default { updateFlag };



// WEBPACK FOOTER //
// ./app/api/FeatureFlagApi.js